// extracted by mini-css-extract-plugin
export default {"userList":"UsersList_userList__dX-OI","tableFlow":"UsersList_tableFlow__sxFzg"};